import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "356",
  height: "356",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "177.808",
      cy: "177.808",
      r: "177.055",
      stroke: "#7540ee",
      "stroke-width": "1.507"
    }, null, -1)
  ]))]))
}
export default { render: render }